"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isOriginallyVector = exports.getPrintQuality = exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _cloneDeep = _interopRequireDefault(require("lodash/cloneDeep"));
var _styles = require("@material-ui/core/styles");
var _withWidth = _interopRequireDefault(require("@material-ui/core/withWidth"));
var _SelectionToolbox = _interopRequireDefault(require("redhotmagma-graphics-editor/Components/SelectionToolbox/SelectionToolbox"));
var _ReactComponent = _interopRequireDefault(require("../../../../../Shared/PropTypes/ReactComponent"));
var _TextControlbox = _interopRequireDefault(require("../TextControlbox"));
var _ImageControlbox = _interopRequireDefault(require("../ImageControlbox"));
var _CustomFontOverlay = require("./CustomFontOverlay");
var _fontItemUtils = require("./fontItemUtils");
var _Selectors = require("../../../../Reducers/DesignArea/Selectors");
var _isMobileDevice = _interopRequireDefault(require("../../../../../Framework/Helpers/isMobileDevice"));
var _Selectors2 = require("../../../../Reducers/DesignData/Selectors");
var _i18n = require("../../../../../Framework/i18n");
var _Transformers = require("../../Utils/Transformers");
var _reactRedux = require("react-redux");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var styles = function styles(theme) {
  return {
    root: _defineProperty({
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2)
    }, theme.orientation.portrait, {
      marginTop: 'auto',
      marginBottom: 0
    }),
    disableTextEditor: {
      userSelect: 'none'
    }
  };
};
var isButtonDisabled = function isButtonDisabled(isBold, isItalic, fontItem, action) {
  return getFontNextState(isBold, isItalic, fontItem.regular, fontItem.bold, fontItem.italic, fontItem.boldItalic, action) === null;
};
var getFontNextState = function getFontNextState(currentBold, currentItalic, regularAvailable, boldAvailable, italicAvailable, boldItalicAvailable, action) {
  var acceptableOutcomes = [];
  if (action === 'bold') {
    acceptableOutcomes.push({
      bold: !currentBold,
      italic: currentItalic
    });
  } else if (action === 'italic') {
    acceptableOutcomes.push({
      bold: currentBold,
      italic: !currentItalic
    });
  }
  acceptableOutcomes.push({
    bold: !currentBold,
    italic: !currentItalic
  });
  var availableAcceptableOutcomes = acceptableOutcomes.filter(function (acceptableOutcome) {
    if (acceptableOutcome.bold) {
      return acceptableOutcome.italic ? boldItalicAvailable : boldAvailable;
    }
    return acceptableOutcome.italic ? italicAvailable : regularAvailable;
  });
  return availableAcceptableOutcomes.length ? availableAcceptableOutcomes[0] : null;
};
var _handleObjectButtonClick = function handleObjectButtonClick(evt, canvas, onMoveUpClick, onMoveDownClick) {
  switch (evt.currentTarget.value) {
    case 'remove':
      {
        canvas.selectedObject.remove();
        break;
      }
    case 'moveUp':
      {
        onMoveUpClick();
        break;
      }
    case 'moveDown':
      {
        onMoveDownClick();
        break;
      }
    case 'alignHorizontalCenter':
      {
        canvas.selectedObject.alignTo(false, 'center');
        break;
      }
    case 'alignVerticalCenter':
      {
        canvas.selectedObject.alignTo('center', false);
        break;
      }
  }
};
var isOriginallyVector = exports.isOriginallyVector = function isOriginallyVector(object) {
  return object && object.type === 'Image' && (0, _Transformers.isOriginalVector)(object.imageData) || false;
};
var isRaster = function isRaster(object) {
  return object && object.type === 'Image' && /\.(jpe?g|png|gif)$/i.test(object.src) || false;
};
var getPrintQuality = exports.getPrintQuality = function getPrintQuality(object) {
  if (!isOriginallyVector(object) && isRaster(object)) {
    if (object.scaling >= 2) {
      return 'poor';
    }
    if (object.scaling > 1) {
      return 'ok';
    }
  }
  return 'great';
};
var DesignerSelectionToolbox = function DesignerSelectionToolbox(props) {
  var classes = props.classes,
    width = props.width,
    openImageEditDialog = props.openImageEditDialog,
    TextControlboxComponent = props.TextControlboxComponent,
    ImageControlboxComponent = props.ImageControlboxComponent,
    CustomFontOverlayComponent = props.CustomFontOverlayComponent,
    colorDisabled = props.colorDisabled,
    fontFamilyList = props.fonts,
    isActiveBulkName = props.isActiveBulkName,
    getTextContent = props.getTextContent,
    isPortraitMode = props.isPortraitMode,
    addCustomFont = props.addCustomFont,
    defaultFont = props.defaultFont,
    loadFonts = props.loadFonts,
    initialColor = props.initialColor,
    autoFocusEditor = props.autoFocusEditor;
  var rteRef = (0, _react.useRef)(null);
  var editorRef = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    showCustomFontOverlay = _useState2[0],
    toggleCustomFontOverlay = _useState2[1];
  var disableLinebreaks = (0, _reactRedux.useSelector)(function (state) {
    return (0, _Selectors.isOneLineText)(state);
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.root
  }, /*#__PURE__*/_react["default"].createElement(_SelectionToolbox["default"], null, function (_ref) {
    var canvas = _ref.canvas,
      selectedObject = _ref.selectedObject,
      onMoveUpClick = _ref.onMoveUpClick,
      onMoveDownClick = _ref.onMoveDownClick,
      TextTools = _ref.components.TextTools;
    if (selectedObject.type === 'Text') {
      return /*#__PURE__*/_react["default"].createElement(TextTools, {
        selectedObject: selectedObject,
        canvas: canvas,
        fullTextCommandList: ['fontSize', 'fontFamily'],
        withStateProvider: true,
        fontFamilyList: fontFamilyList,
        rteRef: rteRef,
        editorRef: editorRef
      }, function (textToolsRenderObj) {
        var canvas = textToolsRenderObj.canvas,
          selectedObject = textToolsRenderObj.selectedObject,
          textToolsClasses = textToolsRenderObj.classes,
          renderTextEditor = textToolsRenderObj.renderTextEditor,
          onChangeHTML = textToolsRenderObj.onChangeHTML,
          _textToolsRenderObj$t = textToolsRenderObj.textEditorState,
          formatDoc = _textToolsRenderObj$t.formatDoc,
          getStyleValues = _textToolsRenderObj$t.getStyleValues,
          fontFamilyList = textToolsRenderObj.fontFamilyList;
        var _getStyleValues = getStyleValues(),
          isBold = _getStyleValues.isBold,
          isItalic = _getStyleValues.isItalic,
          textAlign = _getStyleValues.textAlign,
          fontSize = _getStyleValues.fontSize;
        var color = (0, _isEmpty["default"])(initialColor) ? (0, _cloneDeep["default"])(getStyleValues().color) : initialColor;
        var editorBackgroundColor = (0, _Selectors2.hasBackgroundColor)(selectedObject.style.colors.length > 0 ? selectedObject.style.colors : [color]) ? '#C4C4C4' : '#FFFFFF';
        var currentFontItem = (0, _fontItemUtils.findCurrentFontItem)(fontFamilyList, selectedObject.fontItem);

        // add custom font item
        var translatedAddCustomFont = (0, _i18n.t)('textControlbox.addCustomFont');
        var addCustomFontItem = {
          name: translatedAddCustomFont,
          value: translatedAddCustomFont
        };
        var fontsList = [].concat(_toConsumableArray(fontFamilyList), [addCustomFontItem]);
        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(TextControlboxComponent, {
          selectedObject: selectedObject,
          isActiveBulkName: isActiveBulkName,
          boxed: width !== 'xs',
          isPortraitMode: isPortraitMode,
          textValue: selectedObject.content,
          handleChangeText: onChangeHTML,
          fontValue: currentFontItem,
          fonts: fontsList,
          editorBackgroundColor: editorBackgroundColor,
          color: color,
          handleChangeFont: function handleChangeFont(evt) {
            var fontItem = evt.target.value;
            if (fontItem === addCustomFontItem) {
              toggleCustomFontOverlay(true);
              return;
            }
            canvas.selectedObject.fontItem = (0, _fontItemUtils.createFontItemProps)(fontItem);
          },
          minSize: selectedObject.fontSizeMin,
          maxSize: 1000,
          fontSizeValue: parseInt(fontSize),
          onChangeFontSize: function onChangeFontSize(value) {
            return formatDoc('fontSize', "".concat(value, "px"));
          },
          handleButtonClick: function handleButtonClick(evt) {
            var command = evt.currentTarget.value;
            if (command === 'bold' || command === 'italic') {
              var font = currentFontItem;
              var fontNextState = getFontNextState(isBold, isItalic, font.regular, font.bold, font.italic, font.boldItalic, command);
              if (fontNextState === null) {
                return;
              }
              if (fontNextState.bold !== isBold) {
                formatDoc('bold');
              }
              if (fontNextState.italic !== isItalic) {
                formatDoc('italic');
              }
              return;
            }
            formatDoc(command);
          },
          handleObjectButtonClick: function handleObjectButtonClick(evt) {
            _handleObjectButtonClick(evt, canvas, onMoveUpClick, onMoveDownClick);
          },
          flipToBackDisabled: selectedObject.isFirst,
          flipToFrontDisabled: selectedObject.isLast,
          renderEditorComponent: function renderEditorComponent() {
            var textEditorElementProps = {
              onFocus: function onFocus() {
                if ((0, _Selectors.isPlaceholderContent)(selectedObject.content)) {
                  canvas.selectedObject.content = '';
                }
              },
              onBlur: function onBlur() {
                var regex = /<\/span>/;
                if (selectedObject.content.search(regex) === -1) {
                  canvas.selectedObject.remove();
                }
              }
            };
            if (selectedObject.isBulkName) {
              Object.assign(textEditorElementProps, {
                contentEditable: false,
                className: [textToolsClasses.textEditorContent, classes.disableTextEditor].join(' ')
              });
            }
            return renderTextEditor(_objectSpread(_objectSpread({}, textToolsRenderObj), {}, {
              disableLinebreaks: disableLinebreaks,
              autoFocusWhenMounted: autoFocusEditor || !((0, _Selectors.isPlaceholderContent)(selectedObject.content) || (0, _isMobileDevice["default"])()),
              textEditorElementProps: textEditorElementProps,
              onChangeHTML: function onChangeHTML() {
                // call the original function first with all the args
                textToolsRenderObj.onChangeHTML.apply(textToolsRenderObj, arguments);
                // reload the fonts
                loadFonts(canvas.selectedObject);
              }
            }));
          },
          isBold: isBold,
          boldDisabled: isButtonDisabled(isBold, isItalic, currentFontItem, 'bold'),
          isItalic: isItalic,
          italicDisabled: isButtonDisabled(isBold, isItalic, currentFontItem, 'italic'),
          textAlign: textAlign,
          colorDisabled: colorDisabled,
          isBulkName: selectedObject.isBulkName,
          toggleIsBulkName: function toggleIsBulkName() {
            var isBulkName = !selectedObject.isBulkName;
            canvas.selectedObject.isBulkName = isBulkName;
            canvas.selectedObject.content = getTextContent({
              isBulkName: isBulkName
            });
          }
        }), /*#__PURE__*/_react["default"].createElement(CustomFontOverlayComponent, {
          onClose: function onClose() {
            return toggleCustomFontOverlay(false);
          },
          open: showCustomFontOverlay,
          onApply: function onApply(fontName) {
            var fontItem = _objectSpread(_objectSpread({}, defaultFont), {}, {
              customName: fontName,
              isCustomFont: true
            });
            addCustomFont(fontItem);
            canvas.selectedObject.fontItem = (0, _fontItemUtils.createFontItemProps)(fontItem);
            toggleCustomFontOverlay(false);
          }
        }));
      });
    } else if (selectedObject.type === 'Image' || selectedObject.type === 'Group') {
      return /*#__PURE__*/_react["default"].createElement(ImageControlboxComponent, {
        canvas: canvas,
        boxed: width !== 'xs',
        imageData: selectedObject.imageData,
        printQuality: getPrintQuality(selectedObject),
        openImageEditDialog: openImageEditDialog,
        handleObjectButtonClick: function handleObjectButtonClick(evt) {
          _handleObjectButtonClick(evt, canvas, onMoveUpClick, onMoveDownClick);
        },
        flipToBackDisabled: selectedObject.isFirst,
        flipToFrontDisabled: selectedObject.isLast
      });
    } else {
      // do not show control box for unknown object types
      return null;
    }
  }));
};
DesignerSelectionToolbox.defaultProps = {
  TextControlboxComponent: _TextControlbox["default"],
  ImageControlboxComponent: _ImageControlbox["default"],
  CustomFontOverlayComponent: _CustomFontOverlay.CustomFontOverlay,
  fonts: [],
  colorDisabled: false,
  classes: {},
  width: '',
  isActiveBulkName: false,
  isPortraitMode: false,
  autoFocusEditor: false
};
var _default = exports["default"] = (0, _withWidth["default"])()((0, _styles.withStyles)(styles, {
  name: 'DesignerSelectionToolbox'
})(DesignerSelectionToolbox));